import React from "react";
import "./style.css";
import Header_home from "./Header_home";
import Footer from "./Footer";
import ProductSidebar from "./Product_sidebar";
import ProductDetail from "./Product_detail";

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      api_url: localStorage.getItem("api_url"),
      category_id: localStorage.getItem("category_id"),
      selectedFilters: {
        colors: [],
        sizes: [],
        priceRange: [1500, 55500],
      },
      dynamicFilters: {
        colors: [],
        sizes: [],
        priceRange: { min: 0, max: 55500 },
      },
    };
  }

  // Fetch filters data from the API
  componentDidMount() {
    fetch(`${this.state.api_url}/getfilters`)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          this.setState({
            dynamicFilters: {
              colors: data.filters.colors || [],
              sizes: data.filters.sizes || [],
              priceRange: data.filters.priceRange || { min: 0, max: 55500 },
            },
          });
        } else {
          console.error("Failed to fetch filters");
        }
      })
      .catch((error) => {
        console.error("Error fetching filters:", error);
      });
  }

  // Handler to update selected filters
  handleFilterChange = (newFilters) => {
    this.setState({ selectedFilters: newFilters });
  };

  render() {
    return (
      <div>
        <Header_home />
        <div className="short_line">
          <p className="short_text">Home / Shop</p>
        </div>
        <div className="container">
          <div className="filter">
            <div className="filter2">
              <ProductSidebar
                filters={this.state.dynamicFilters} // Pass dynamic filters
                onFilterChange={this.handleFilterChange}
              />
            </div>
          </div>
          <div className="itemss">
            <ProductDetail filters={this.state.selectedFilters} />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Product;
